import { getPlatform } from "./common";
import qs from "qs";
class NATIVE {
  /**
   *
   * @param {*} aFunc 安卓处理函数
   * @param {*} iFunc 苹果系统处理函数
   */
  static trigger(aFunc = () => {}, iFunc = () => {}) {
    if (getPlatform() === "aphone") {
      try {
        aFunc();
      } catch (e) {
        console.log("安卓系统，非APP环境");
      }
    } else if (getPlatform() === "iphone") {
      try {
        iFunc();
      } catch (e) {
        console.log("苹果系统，非APP环境");
      }
    } else {
      console.log("未知系统");
    }
  }
  // app下载文件
  static downloadFile(FileUrl) {
    this.trigger(
      () => {
        window.SpeedBiz.downloadFile(FileUrl);
      },
      () => {
        window.webkit.messageHandlers.downloadFile.postMessage(FileUrl);
      }
    );
  }
  // app发起微信分享
  static shareH5(title, desc, url, thumbnail) {
    this.trigger(
      () => {
        window.SpeedBiz.shareUrl(title, desc, url, thumbnail);
      },
      () => {
        window.webkit.messageHandlers.shareUrl.postMessage(
          JSON.stringify({
            title,
            desc,
            url,
            thumbnail
          })
        );
      }
    );
  }
  // app关闭webview
  static closeH5() {
    this.trigger(
      () => {
        window.SpeedBiz.finishActivity();
      },
      () => {
        window.webkit.messageHandlers.finishActivity.postMessage("");
      }
    );
  }
  // app设置顶部栏的背景颜色
  static setAppTopBarColor(color = "#FFFFFF") {
    this.trigger(
      () => {
        window.SpeedBiz.setStatusBarColor(color);
      },
      () => {
        window.webkit.messageHandlers.setStatusBarColor.postMessage(color);
      }
    );
  }
  // 获取app登录的token
  static getUserAuthToken = () => {
    const parseQuerySearch = () => window.location.search.replace("?", "");
    const qSearch = parseQuerySearch();
    const { token } = qs.parse(qSearch);
    if (token) {
      return Promise.resolve(token);
    }
    let tokenPromise;
    try {
      if (window.SpeedBiz && getPlatform() === "aphone") {
        tokenPromise = Promise.resolve(window.SpeedBiz.getLocalToken());
      } else if (getPlatform() === "iphone") {
        tokenPromise = new Promise(resolve => {
          window.getIOSLocalToken = iosToken => {
            resolve(iosToken || "");
          };
        });
        window.webkit.messageHandlers.getLocalToken.postMessage("");
      } else {
        tokenPromise = Promise.resolve(token);
      }
      return tokenPromise;
    } catch (e) {
      return Promise.resolve(token);
    }
  };
  static isAPP() {
    try {
      if (getPlatform() === "aphone") {
        window.SpeedBiz.getLocalToken();
      } else if (getPlatform() === "iphone") {
        window.webkit.messageHandlers.getLocalToken.postMessage("");
      } else {
      }
    } catch (e) {
      return false;
    }
    return true;
  }
  static getAppLanguage() {
    const defaultInfo = navigator.language || "en-US"; // en-US zh-CN
    const languageMap = {
      "zh-CN": "zh-CN",
      "zh-cn": "zh-CN",
      cn: "zh-CN",
      "en-US": "en-US",
      "en-us": "en-US",
      en: "en-US",
      "ms-MY": "ms-MY",
      "ms-my": "ms-MY",
      ms: "ms-MY",
      "th-TH": "th-TH",
      "th-th": "th-TH",
      th: "th-TH"
    };
    let languagePromise;
    try {
      if (getPlatform() === "aphone") {
        languagePromise = Promise.resolve(languageMap[window.SpeedBiz.getAppLanguage()] || languageMap[defaultInfo]);
      } else if (getPlatform() === "iphone") {
        languagePromise = new Promise((resolve, reject) => {
          window.getIOSAppLanguage = language => {
            resolve(languageMap[language] || languageMap[defaultInfo]);
          };
        });
        window.webkit.messageHandlers.getAppLanguage.postMessage("");
      } else {
        languagePromise = Promise.resolve(languageMap[defaultInfo]);
      }
    } catch (e) {
      // languagePromise = Promise.resolve("en-US");

      languagePromise = Promise.resolve(languageMap[defaultInfo]);
    }
    return languagePromise;
  }
  static setAddress(addressStr) {
    console.log("addressStr", addressStr);
    this.trigger(
      () => {
        window.SpeedBiz.receiveAddress(addressStr);
      },
      () => {
        window.webkit.messageHandlers.receiveAddress.postMessage(addressStr);
      }
    );
  }
  static getAppCurrencyInfo() {
    const defaultInfo = "￥,元";
    let currencyPromise;
    try {
      if (getPlatform() === "aphone") {
        currencyPromise = Promise.resolve(window.SpeedBiz.getAppCurrencyInfo() || defaultInfo);
      } else if (getPlatform() === "iphone") {
        currencyPromise = new Promise((resolve, reject) => {
          window.getIOSAppCurrencyInfo = language => {
            resolve(language || defaultInfo);
          };
        });
        window.webkit.messageHandlers.getAppCurrencyInfo.postMessage("");
      } else {
        currencyPromise = Promise.resolve(defaultInfo);
      }
    } catch (e) {
      currencyPromise = Promise.resolve(defaultInfo);
    }
    return currencyPromise;
  }
  // 保存图片到相册 参数为完整的base64
  static saveBase64Pic2Album(base64Str) {
    this.trigger(
      () => {
        window.SpeedBiz.saveBase64Pic2Album(base64Str);
      },
      () => {
        window.webkit.messageHandlers.saveBase64Pic2Album.postMessage(base64Str);
      }
    );
  }
  // 保存图片到相册 参数为完整的url
  static savePic2Album(url) {
    this.trigger(
      () => {
        window.SpeedBiz.savePic2Album(url);
      },
      () => {
        window.webkit.messageHandlers.savePic2Album.postMessage(url);
      }
    );
  }
  static getStoreQueryTutorials() {
    let promise;
    const defaultInfo = "{}";
    try {
      if (getPlatform() === "aphone") {
        promise = Promise.resolve(window.SpeedBiz.storeQueryTutorials() || defaultInfo);
      } else if (getPlatform() === "iphone") {
        promise = new Promise((resolve, reject) => {
          window.getIOSStoreTutorials = dataStr => {
            resolve(dataStr || defaultInfo);
          };
        });
        window.webkit.messageHandlers.storeQueryTutorials.postMessage("");
      } else {
        promise = Promise.resolve(defaultInfo);
      }
    } catch (e) {
      promise = Promise.resolve(defaultInfo);
    }
    return promise;
  }
  // 消息跳转（门店通和赢在一起） 参数为消息数据（josn）
  static msgIntentPage(msgData) {
    const msgStr = msgData ? JSON.stringify(msgData) : "";
    this.trigger(
      () => {
        window.SpeedBiz.msgIntentPage(msgStr);
      },
      () => {
        window.webkit.messageHandlers.msgIntentPage.postMessage(msgStr);
      }
    );
  }
  // 打开带标题的webview（汽配通和积分商城） 参数: 外部链接
  static msgIntentExternalLink(url) {
    if (!url) return;
    this.trigger(
      () => {
        window.SpeedBiz.msgIntentExternalLink(url);
      },
      () => {
        window.webkit.messageHandlers.msgIntentExternalLink.postMessage(url);
      }
    );
  }
}

export default NATIVE;



// WEBPACK FOOTER //
// ./src/utils/native.js